/**
 * 视图类型: 我的一天 / 重要 / 已完成 / 归档 / 某个 list
 */

export type View =
  | { kind: 'my-day' }
  | { kind: 'important' }
  | { kind: 'planned' }
  | { kind: 'all' }
  | { kind: 'completed' }
  | { kind: 'archived' }
  | { kind: 'list'; listId: string };

export const VIEWS = {
  myDay: { kind: 'my-day' } as View,
  important: { kind: 'important' } as View,
  planned: { kind: 'planned' } as View,
  all: { kind: 'all' } as View,
  completed: { kind: 'completed' } as View,
  archived: { kind: 'archived' } as View,
};

export function viewKey(v: View): string {
  return v.kind === 'list' ? `list:${v.listId}` : v.kind;
}